const getMoveIndex = (
  mouseEventDirection,
  elPosition,
  elDimension,
  movementSpeed
) => {
  let relativePos = mouseEventDirection - elPosition;
  return (relativePos - elDimension / 2) / movementSpeed;
};

export default getMoveIndex;
